if (!customElements.get('article-toc-nav')) {
  const hideTocNav = (host) => {
    host.hidden = true;
  };

  /** Visible text for an h2; empty string if the heading is blank (e.g. empty nested spans). */
  const headingLabel = (el) => el.textContent.replace(/\s+/g, ' ').trim();

  const usedIdsInRoot = (root) => {
    const ids = new Set();
    for (const el of root.querySelectorAll('[id]')) {
      if (el.id) ids.add(el.id);
    }
    return ids;
  };

  const makeSlugId = (label, ids, index) => {
    let base = label
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (!base) base = `article-section-${index + 1}`;

    let id = base;
    let n = 2;
    while (ids.has(id)) {
      id = `${base}-${n}`;
      n += 1;
    }
    ids.add(id);
    return id;
  };

  customElements.define(
    'article-toc-nav',
    class ArticleTocNav extends HTMLElement {
      connectedCallback() {
        const rootId = this.dataset.contentId;
        const root = rootId ? document.getElementById(rootId) : null;
        const rawHeadings = root?.querySelectorAll('h2');
        const headings = rawHeadings ? [...rawHeadings].filter((el) => headingLabel(el).length > 0) : [];
        if (!root || headings.length === 0) {
          hideTocNav(this);
          return;
        }

        const list = this.querySelector('[data-toc-list]');
        if (!list) return;

        const ids = usedIdsInRoot(root);
        const frag = document.createDocumentFragment();

        for (const [i, heading] of headings.entries()) {
          const label = headingLabel(heading);
          let id = heading.id?.trim();
          if (id) {
            ids.add(id);
          } else {
            id = makeSlugId(label, ids, i);
            heading.id = id;
          }

          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${id}`;
          a.textContent = label;
          li.appendChild(a);
          frag.appendChild(li);
        }

        list.replaceChildren(frag);
        this.querySelector('[data-toc-inner]')?.removeAttribute('hidden');
      }
    }
  );
}
